import { Format } from '@swegaming-ab/nuxtjs-helpers';
import Base from './Base.js';

export default class BaseWithFormatting extends Base {

    formatCurrency(value, decimals = 0) {
        return Format.currency(value, decimals);
    }

    formatCurrencyRange(v1, v2, decimals = 0) {
        return `${this.formatNumber(v1, decimals)} - ${this.formatCurrency(v2, decimals)}`;
    }

    formatNumber(value, decimals = 0) {
        return Format.number(value, decimals);
    }

    formatPercentage(value, decimals = 0) {
        return `${this.formatNumber(value, decimals)} %`;
    }

    formatPercentageRange(v1, v2, decimals = 0) {
        return `${this.formatNumber(v1, decimals)} - ${this.formatNumber(v2, decimals)} %`;
    }
}